// Bug AD-358
// from https://stackoverflow.com/a/11463939/5225096

export const killCache = url =>
  url.includes('?') ? `${url}&killCache${Date.now()}` : `${url}/?killCache${Date.now()}`;
